module.exports = __webpack_public_path__ + "static/gallery21-f26a5d088d69db37e642ff7dc2e6d7b8.png";